import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/HeaderReceptionist";
import { ReceptionSidebar } from "../Layouts/ReceptionSidebar";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";

export class ConfirmPatient extends Component {
  constructor(props) {
    super(props);
    

    this.state = {
      procedurename: "",
      paymentstype: "",
      paymentsrefcode: "",
      paymentsamount: "",
      DataLoaded: false,
      confirmLoading: false,
      procedureLoading: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleRowClick = this.handleRowClick.bind(this);
  }

  handleRowClick(patient) {
 
    $(".confirmPayment").show();
    $(".startTreatment").attr("id", patient.visitid);
    var details =
      patient.Name + " (" + patient.Age + ")- " + patient.Nationality;
    $(".patientName").text(details);
    localStorage.removeItem("confirmVisitId")
    localStorage.setItem("confirmVisitId", patient.visitid);
    localStorage.removeItem("confirmModule");
    localStorage.setItem("confirmModule", patient.module);
    const headers = {
      'Content-Type': 'application/json',
      'token': localStorage.getItem('accessToken'),
      'visitid':patient.visitid
      // 'visitid': localStorage.getItem('visitId')
  }
  this.setState({
    procedureLoading: true
  })
  axios.get(this.api_url+"billing/pendingpayments", { headers: headers })
  .then(res => {
      const procedurecosts = res.data;
      this.setState({
        procedureLoading: false
      })

      Object.keys(procedurecosts).forEach(cost => {
          if(cost !== "total_paid" &&  cost !== "total_pending")
          {
              var option = "<option value=" + cost + ">" + cost+"</option>"
              $('.procedureNamePosition').append(option)
          }

      });

      //   this.setState({ procedurecosts });
  })
    
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });

    if(event.target.name == "paymentstype")
    {
    
      if(event.target.value == "Zaad" || event.target.value == "e-Dahab")
      {
        $('.paymentefcode').prop('required',true);
      }
      
    }
  }
  handleSubmit(event) {
    // alert(localStorage.getItem('confirmVisitId'))
    event.preventDefault();
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("confirmVisitId"),
    };
    event.preventDefault();
   this.setState({
    confirmLoading: true
   })
    axios
      .post(this.api_url+"billing/update/paid", this.state, {
        headers: headers,
      })
      .then((response) => {
        this.setState({
          confirmLoading: false
         })
        if (
          window.confirm("Are you sure you want to confirm patient?") == true
        ) {
          $("#loginSuccess").show();

          $(".modal").hide();
          const headers = {
            "Content-Type": "application/json",
            token: localStorage.getItem("accessToken"),
            visitid: localStorage.getItem("confirmVisitId"),
          };
         
          axios.post(this.api_url+"billing/status/" +localStorage.getItem("confirmModule")+"/confirm",
              this.state,
              { headers: headers }
            )
            .then((response) => {
              window.location.reload();
              $(this).attr("class", "btn btn-success");
              $(this).prop("disabled", true);

              $(".form-control").attr("value", "");

              // $('.confirmedMessage').show()();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
     
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  }

  componentDidMount() {
    const displayHidden = { display: "none" };
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
    };


    
  
    axios.get(this.api_url+"billing/status/triage/open", { headers: headers })
      .then((res) => {
       
        const unconfirmedAccounts = res.data;
   
          let tableinit = new Array();
          for (var i = 0; i < unconfirmedAccounts.length; i++) {
         
            if(res.data[i]["status"] !== ""){
                    
                var number = i + 1;
              tableinit.push(res.data[i]);
                 for (let i = 0; i < tableinit.length; i++) {
                  delete tableinit[i]._id;
                  delete tableinit[i].timeOfRegistration;
                  tableinit[i].clickEvent = () =>
                    this.handleRowClick(tableinit[i]);
                }
           
                var table = Object.assign(tableinit);
                this.TableData = table;
              this.setState({
                  DataLoaded: true,
                });
     
              }
          
          }
         
        
          
      });
    this.setState({
      visitBillingSerial: (Math.random() + 1).toString(36).substring(7),
      paymentspending: (Math.random() + 1).toString(36).substring(7),
      paymentspending: "default",
      paymentstime: "default",
      paymentsstatus: "default",
    });
   
    $(".numberRow1").on("click", function () {
       var visitid = $(this).attr("id");     
    });
  }
  
  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const { procedurename, paymentstype, paymentsrefcode, paymentsamount, confirmLoading } =
      this.state;
      let { DataLoaded } = this.state;
      const tabledata = {
        columns: [
           {
            label: "Visit ID",
            field: "visitid",
            sort: "asc",
            width: 50,
          },
          {
            label: "Name",
            field: "Name",
            sort: "asc",
            width: 50,
          },
          {
            label: "Age",
            field: "Age",
            sort: "asc",
            width: 50,
          },
          {
            label: "Profession",
            field: "Profession",
            sort: "asc",
            width: 50,
          },
          {
            label: "Marital Status",
            field: "MaritalStatus",
            sort: "asc",
            width: 50,
          },
          {
            label: "Address",
            field: "Address",
            sort: "asc",
            width: 50,
          },
          {
            label: "Mobile Phone Number",
            field: "Tel ",
            sort: "asc",
            width: 50,
          },
          {
            label: "Nationality",
            field: "Nationality",
            sort: "asc",
            width: 50,
          },
  
          {
            label: "Date of Birth",
            field: "Dateofbirth",
            sort: "asc",
            width: 50,
          },
          {
            label: "Education",
            field: "Education",
            sort: "asc",
            width: 50,
          },
          {
            label: "Module",
            field: "module",
            sort: "asc",
            width: 50,
          },
         
  
          {
            label: "Status",
            field: "modulestatus",
            sort: "asc",
            width: 50,
          },
        ],
        rows: this.TableData,
      };
    return (
      <div>
        <Headers />
        <ReceptionSidebar></ReceptionSidebar>
        <main>
          <div className="content-container">
            <form>
              <div className="form-row PreplanTable">
                <div className="col-md-4 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>Billing and Confirmation</p>
                </div>
                
                  
                  <MDBDataTable striped bordered data={tabledata} />
                  
                
              </div>
            </form>
          </div>
        </main>
        <div className="modal confirmPayment" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title patientName"> </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form id="formId" onSubmit={this.handleSubmit}>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Procedure Name
                    </h6>
                    <select
                      className="form-control procedureNamePosition"
                      onChange={this.handleChange}
                      value={procedurename}
                      name="procedurename"
                      required
                    >
                      <option selected disabled defaultValue=""></option>

                      {/* <option value="lab_procedure">Lab Procedure</option>
                                                    <option value="triage">Triage</option> */}
                    </select>
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Payments Type
                    </h6>
                    <select
                      className="form-control"
                      onChange={this.handleChange}
                      value={paymentstype}
                      name="paymentstype"
                      required
                    >
                      <option selected disabled></option>
                      <option value="cash">Cash</option>
                      <option value="Zaad">Zaad</option>
                      <option value="e-Dahab">e-Dahab</option>
                      {/* <option value="triage">Triage</option> */}
                    </select>
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Payments Ref Code
                    </h6>
                    <input
                      className="form-control paymentrefcode"
                      onChange={this.handleChange}
                      value={paymentsrefcode}
                      name="paymentsrefcode"
                      
                    />
                  </div>
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Payments Amount
                    </h6>
                    <input
                      className="form-control"
                      type="number"
                      onChange={this.handleChange}
                      value={paymentsamount}
                      name="paymentsamount"
                      required
                    />
                  </div>

                  <button
                    className="btn btn-success startTreatment"
                    type="submit"
                  >
                   {confirmLoading ? 'Loading' : 'Confirm Payment'} 
                  </button>
                  <div
                    id="loginSuccess"
                    className="alert alert-success"
                    style={displayHidden}
                    role="alert"
                  >
                    <strong>Success! </strong>Patient Confirmed Successfully
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmPatient;
